import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";

import { Link } from 'react-router-dom';
import myVideo from './video/Dirty_Yachtin_Scoundrels_LOOP2.mp4';
import myVideoWebm from './video/Dirty_Yachtin_Scoundrels_LOOP2.webm';
import Reviews from './sub-components/review';
import Merch from './sub-components/Merch';

import { Helmet } from 'react-helmet-async';

// Keep these in sync with the "/" entry in SeoPageRenderer.cs
const PAGE_URL = "https://www.dysband.com/";
const PAGE_TITLE = "Dirty Yachtin' Scoundrels | Yacht Rock Band from Phoenix";
const PAGE_DESCRIPTION =
    "Experience the smooth sounds of the '70s and '80s with Dirty Yachtin' Scoundrels, a Phoenix, Arizona-based band delivering unforgettable live events for weddings, parties, and corporate gigs.";
const PAGE_IMAGE =
    "https://www.dysband.com/media/yacht_rock_band_dirty_yachtin_scoundrels_live.webp";

const Home = () => { // (Arrow Function Declaration)
    return (
        <div>
            <Helmet>
                <title>{PAGE_TITLE}</title>
                <meta name="description" content={PAGE_DESCRIPTION} />

                {/* Open Graph Tags */}
                <meta property="og:title" content={PAGE_TITLE} />
                <meta property="og:description" content={PAGE_DESCRIPTION} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={PAGE_URL} />
                <meta property="og:site_name" content="Dirty Yachtin' Scoundrels" />
                <meta property="og:image" content={PAGE_IMAGE} />
                <meta property="og:image:alt" content="Dirty Yachtin' Scoundrels performing live on stage under the stars." />

                {/* Twitter Card Tags */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={PAGE_TITLE} />
                <meta name="twitter:description" content={PAGE_DESCRIPTION} />
                <meta name="twitter:image" content={PAGE_IMAGE} />

                <link rel="canonical" href={PAGE_URL} />
            </Helmet>

            <div className="col-12 bio">
                <h1 className="bio_span">Dirty Yachtin' Scoundrels</h1>
                <p className="bio_span">
                    Dirty Yachtin' Scoundrels is a Phoenix-based yacht rock band performing the smooth hits of the 70s and 80s. With spot-on vocals, tight harmonies, and a polished live sound, the band brings classics from artists like Toto, Steely Dan, and Hall & Oates to life for audiences of all ages.
                </p>
                <p className="bio_span">
                    Whether it's a festival, wedding, corporate event, or private party, Dirty Yachtin' Scoundrels delivers a crowd-pleasing set of yacht rock favorites that keep people singing and dancing from the first song to the last.
                </p>
                <p className="bio_span">
                    Based in Phoenix, Arizona, Dirty Yachtin' Scoundrels plays weddings, corporate events, private parties, festivals, and public shows in the Phoenix area, across Arizona, and nationwide. See the <Link to="/Calendar">upcoming shows</Link>, watch <Link to="/Video">live videos</Link>, learn more about <Link to="/yacht-rock-band">hiring a yacht rock band in Phoenix</Link>, or <Link to="/Contact">contact the band</Link> to ask about your date.
                </p>
                <h2 className="bio_span">What is yacht rock?</h2>
                <p className="bio_span">
                    Yacht rock is the smooth, polished soft rock of the late 1970s and early 1980s, known for silky vocal harmonies, warm keyboards, and melodies that are easy to sing along with.
                </p>
            </div>
            <Merch />
            <Reviews />

            <div className="parallax-container">
                <video autoPlay muted loop playsInline className="background-video">
                    <source src={myVideoWebm} type="video/webm" />
                    <source src={myVideo} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>

                <div className="content">
                    <section className="hero">
                        {/* was a second <h1>; a page should have only one */}
                        <h2>Yacht rock classics and soft grooves... live and loud!</h2>
                    </section>
                </div>
            </div>

            <div className="parallax-hero">
                <div className="hero-content">
                    <p>Come Play With Us!!</p>
                </div>
            </div>
        </div>
    );
}
export default Home